import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import { Link } from 'react-router-dom';

import { toggleCalendarHidden } from '~/Redux/Modules/CalendarAccounts';
import { updateUserOptions } from '~/Redux/Modules/UserOptions';

import './CalendarList.scss';

class CalendarList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  render() {
    const { account, toggleHidden, userOptions, updateUserOptions } = this.props;
    const { expanded } = this.state;
    const hidden = account.calendars.filter(calendar => calendar.is_hidden).length;
    return (
      <div className="calendar-list">
        {account.calendars
          .sort((a, b) => a.is_hidden - b.is_hidden)
          .filter(calendar => expanded || !calendar.is_hidden)
          .map((calendar, index) => {
            return (
              <div className="calendar-list__calendar" key={index}>
                <div className="calendar-list__calendar__hidden-status" key="hidden-status">
                  <FontAwesome
                    name={`check-circle ${calendar.is_hidden ? 'inactive' : 'active'}`}
                    onClick={() => toggleHidden(calendar.id, !calendar.is_hidden)}
                  />
                </div>
                <Link
                  to={`/calendars/${calendar.id}`}
                  className="calendar-list__calendar__name"
                  key="name"
                  style={{ color: calendar.color }}
                >
                  {calendar.display_name}
                </Link>
                {calendar.id === userOptions.calendar_id && (
                  <div className="calendar-list__calendar__default-status" key="default-status">
                    Default
                  </div>
                )}
              </div>
            );
          })}
        {!expanded && hidden > 0 && (
          <div
            className="calendar-list__show-more"
            onClick={() => this.setState({ ...this.state, expanded: true })}
          >
            Show {hidden} more
          </div>
        )}
      </div>
    );
  }
}

CalendarList.propTypes = {
  account: propTypes.object,
  userOptions: propTypes.object,
  toggleHidden: propTypes.func,
  updateUserOptions: propTypes.func,
};

const mapStateToProps = ({ UserOptions }) => {
  return {
    userOptions: UserOptions.data,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleHidden: (calendar_id, status) => dispatch(toggleCalendarHidden(status, calendar_id)),
    updateUserOptions: (id, data) => dispatch(updateUserOptions(id, data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarList);
